/** Textos UI en UTF-8 explícito (evita mojibake en bundles servidos sin charset). */
export const UI = {
  title: 'Casa Le\u00f3n Vivo 3D',
  subtitle: 'CL-VIVO-009 \u00b7 Personajes premium + editor en grilla',
  sectionMode: 'Modo',
  modeSim: 'Simulaci\u00f3n',
  modeEdit: 'Edici\u00f3n',
  editorHelp:
    'Arrastr\u00e1 mesas: se ajustan a la grilla l\u00f3gica del piso. Colisiones y ocupaci\u00f3n bloquean el movimiento.',
  editorUndo: 'Deshacer',
  editorRedo: 'Rehacer',
  editorResetLayout: 'Layout predeterminado',
  editorRotate: 'Rotar mesa seleccionada',
  editorDuplicate: 'Duplicar planta decorativa',
  editorSave: 'Guardar layout',
  editorSaved: 'Guardado',
  sectionCamera: 'C\u00e1mara',
  sectionGuests: 'Comensales (simulado)',
  sectionTables: 'Mesas y escenarios',
  cameraIso: 'Vista isom\u00e9trica',
  cameraSalon: 'Enfoque sal\u00f3n',
  cameraPatio: 'Enfoque patio',
  guestSimNote: 'Flujo demo: ingreso, espera, mesa, consumo y retiro. No son datos reales de ventas.',
  guestParty2: 'Ingreso pareja (sim.)',
  guestParty6: 'Ingreso grupo 6 (sim.)',
  floorStatus: 'Estado del piso',
  charsLoading: 'Cargando personajes\u2026',
  charsReady: 'Personajes premium',
  pilotService: 'Piloto: cliente + mozo (mesa 3)',
  soundOn: 'Activar sonido',
  soundToggle: 'Sonido ambiental / alertas',
  hideScenarios: 'Ocultar escenarios',
  showScenarios: 'Escenarios',
  cameraHelp: 'C\u00e1mara: arrastrar \u00b7 zoom \u00b7 WASD',
  resetDemo: 'Reiniciar demo',
  resetView: 'Vista inicial',
  scenario: (key: string) => `Escenario ${key}`,
  interactHint:
    'Hac\u00e9 clic en el pizarr\u00f3n, estaci\u00f3n meteorol\u00f3gica, WhatsApp, tel\u00e9fono, caja o una mesa.',
  panelWeather: 'Clima \u2014 Los Corralitos',
  weatherUnavailable: 'No hay datos meteorol\u00f3gicos disponibles en este momento.',
  feelsLike: 'Sensaci\u00f3n',
  rainChance: 'Prob. lluvia (pr\u00f3x. hora)',
  wind: 'Viento',
  hourlyForecast: 'Pr\u00f3ximas horas',
  dailyForecast: 'Pr\u00f3ximos 3 d\u00edas',
  updated: 'Actualizado',
  staleData: 'dato en cach\u00e9',
  source: 'Fuente',
  weatherEffects: 'Efectos clim\u00e1ticos en escena',
  weatherRefresh: 'Actualizar clima',
  splashWelcome: 'Bienvenido a Casa Le\u00f3n Vivo 3D',
  panelKitchen: 'Pizarr\u00f3n \u2014 pedidos (simulado)',
  panelWhatsApp: 'WhatsApp \u2014 actividad bot',
  panelPhone: 'Tel\u00e9fono',
  panelRegister: 'Caja \u2014 cobros simulados',
  panelTable: (id: string) => `Mesa ${id}`,
  panelInteract: 'Interactividad',
  tableHelp:
    'Pedido y atenci\u00f3n sincronizados con el snapshot demo. Us\u00e1 los escenarios laterales para cambiar estados.',
  zone: 'Zona',
  cashOpen: 'abierta',
  cashClosed: 'cerrada',
  salesToday: 'Ventas hoy',
  state: 'Estado',
} as const;
